<div class="xcard" [class.answered]="answered">
  <h4 class="x-title">{{ title }}</h4>
  <p class="x-sub" *ngIf="subtitle">{{ subtitle }}</p>
  <p class="x-reason" *ngIf="reason">
    <i class="bi bi-exclamation-circle" aria-hidden="true"></i><span>{{ reason }}</span>
  </p>

  <div class="pair">
    <div class="side">
      <div class="tag">In Sage</div>
      <b>{{ sageName }}</b>
      <div class="side-meta" *ngIf="sageMeta">{{ sageMeta }}</div>
    </div>
    <div class="pair-arrow" aria-hidden="true"><i class="bi bi-arrow-left-right"></i></div>
    <div class="side" [class.side-empty]="!aivorName">
      <div class="tag">In Aivor</div>
      <b *ngIf="aivorName">{{ aivorName }}</b>
      <div class="side-meta" *ngIf="aivorName && aivorMeta">{{ aivorMeta }}</div>
      <div class="side-missing" *ngIf="!aivorName">{{ missingLabel }}</div>
    </div>
  </div>

  <div class="choices">
    <button
      type="button"
      class="choice"
      *ngFor="let option of options"
      [class.on]="choice === option.key"
      [attr.aria-pressed]="choice === option.key"
      [disabled]="saving"
      (click)="choose.emit(option.key)"
    >
      <b>{{ option.title }}</b>{{ option.text }}
    </button>
  </div>

  <div class="picked-note" *ngIf="choice === 'picked'">
    <i class="bi bi-check-circle-fill"></i> Linked to {{ aivorName }}. Aivor keeps its name.
  </div>

  <div class="picker-row">
    <button type="button" class="link-btn" [attr.aria-expanded]="pickerOpen" (click)="togglePicker()">
      {{ pickLabel }} <i class="bi" [ngClass]="pickerOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
    </button>
  </div>

  <div class="picker" *ngIf="pickerOpen">
    <div class="picker-search">
      <i class="bi bi-search"></i>
      <input type="text" [(ngModel)]="query" [attr.aria-label]="'Search Aivor ' + noun + ' records'" placeholder="Search by name or code" />
    </div>
    <div class="picker-list" role="listbox">
      <button
        type="button"
        class="picker-item"
        role="option"
        *ngFor="let record of candidates"
        [disabled]="saving || !!claimedBy(record)"
        (click)="pickRecord(record)"
      >
        <span class="picker-name">{{ record.name }}</span>
        <span class="picker-meta" *ngIf="record.meta">{{ record.meta }}</span>
        <span class="picker-claimed" *ngIf="claimedBy(record) as other">Matched to {{ other }}</span>
      </button>
      <div class="picker-empty" *ngIf="!candidates.length">No Aivor {{ noun }} matches your search.</div>
    </div>
    <div class="picker-more" *ngIf="candidateTotal > candidates.length">
      Showing {{ candidates.length }} of {{ candidateTotal }}. Search to narrow it down.
    </div>
  </div>
</div>
